import { Injectable } from '@angular/core';
import { AlarmAgentApiClient } from '.';

@Injectable({
	providedIn: 'root',
})
export class SimParameterLogService {
	private API_ROUTE = 'parameterslog';

	constructor(private http: AlarmAgentApiClient) {}

	async getLogs(rtuId: any): Promise<SimParameterLog[]> {
		return this.http.get(`${this.API_ROUTE}/${rtuId}`).toPromise();
	}

}

export class SimParameterLog {
	id?: number;
	rtuId?: number;
	date?: Date;
	user?: string;
	changedField?: string;
	oldValue?: string;
	newValue?: string;
}

export class SimParameterLogNew {
	rtuId?: number;
	user?: string;
	changedField?: string;
	oldValue?: string;
	newValue?: string;
}
